import {customAlphabet} from 'nanoid/non-secure'
const nanoid = customAlphabet(`abcdefghijklmnopqrtsuvwxyz1234567890`, 8)
const generate =
    () => {
      return nanoid()
    }

export default generate
